import { render, staticRenderFns } from "./regionMarkTip.vue?vue&type=template&id=7851fba4&scoped=true&"
import script from "./regionMarkTip.vue?vue&type=script&lang=js&"
export * from "./regionMarkTip.vue?vue&type=script&lang=js&"
import style0 from "./regionMarkTip.vue?vue&type=style&index=0&id=7851fba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7851fba4",
  null
  
)

export default component.exports